import { render, staticRenderFns } from "./PermissionsEditor.vue?vue&type=template&id=1f5dff4a&scoped=true"
import script from "./PermissionsEditor.vue?vue&type=script&lang=js"
export * from "./PermissionsEditor.vue?vue&type=script&lang=js"
import style0 from "./PermissionsEditor.vue?vue&type=style&index=0&id=1f5dff4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f5dff4a",
  null
  
)

export default component.exports